module.exports = __webpack_public_path__ + "img/ntk_timeline_last.42c05874.svg";